import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {Calendar, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {schoolClassInterface} from "../center/add-edit-center-class";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {DateFixToGoLayout, GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";

export const AdminsAddEditConsentModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    isEdit: boolean,
    consentId: number
}) => {
    const fetchData = (consentID: number) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consents/get',
            {
                consentId: consentID.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                forAll: 0 | 1,
                classId: number,
                class: string,
                expiresAt: string,
                createdAt: string,
                about: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setTitle(d.title);
                setAbout(d.about);
                setMode(d.forAll === 1 ? 'all' : (d.classId > 0 ? 'class' : 'students'));
                setClassSelected(d.classId);
                const _expiresAt = GregorianToPersian(d.expiresAt).split(" ");
                const t = _expiresAt[0].split("-");
                setExpiresAt({
                    year: parseInt(t[0]),
                    month: parseInt(t[1]),
                    day: parseInt(t[2]),
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const edit = props.isEdit;
        const oldId = props.consentId;
        if (isActive) {
            setMode('');
            setTitle('');
            setClassSelected(0);
            fetchClasses(edit ? () => fetchData(oldId) : () => {
            });
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [mode, setMode] = useState('' as '' | 'all' | 'class' | 'students');
    const [expiresAt, setExpiresAt] = useState<DayValue>(null);
    const [title, setTitle] = useState('');
    const [about, setAbout] = useState('');
    const [classes, setClasses] = useState([] as schoolClassInterface[]);
    const [classSelected, setClassSelected] = useState(0);
    const ids = {
        title: useId(),
        about: useId(),
    };
    const fetchClasses = (onDone: any) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/get-school-classes',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: schoolClassInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: schoolClassInterface[] = d.list === null ? [] : d.list;
                setClasses(lst);
                onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const saveChanges = () => {
        const _mode = mode;
        if (expiresAt === null) {
            ShowSnackbar('لطفا تاریخ پایان را مشخص نمایید.', 'باشه', 5000);
            return;
        }
        const _expiresAt = PersianToGregorian(DateFixToGoLayout(`${expiresAt?.year}-${expiresAt?.month}-${expiresAt?.day}`)) + " 23:59:59";
        const _title = title.trim();
        const _classSelected = classSelected;
        const _about = about.trim();
        if (_title.length < 2) {
            ShowSnackbar('لطفا برای عنوان حداقل ۲ کاراکتر وارد کنید.', 'باشه', 5000);
            return;
        }
        if (_mode === 'class' && _classSelected === 0) {
            ShowSnackbar('لطفا یک کلاس را انتخاب نمایید.', 'باشه', 5000);
            return;
        }
        const isEdit = props.isEdit;
        const oldID = props.consentId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consents/' + (isEdit ? 'edit' : 'add'),
            {
                title: _title,
                mode: _mode,
                classID: _classSelected.toString(),
                expiresAt: _expiresAt,
                consent: oldID.toString(),
                about:_about,
            },
            true,
            (d: {
                result: string,
                reason: string,
                id: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'رضایت‌نامه ثبت شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-xl" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>{props.isEdit ? 'ویرایش رضایت‌نامه' : 'افزودن رضایت‌نامه'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="add-student">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label htmlFor={ids.title}>عنوان رضایت‌نامه:</label>
                                    <input type="text"
                                           id={ids.title}
                                           value={title}
                                           className={"form-control"}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setTitle(t);
                                           }}
                                    />
                                    <div style={{height: 15}}/>
                                    <label htmlFor={ids.about}>متن رضایت‌نامه:</label>
                                    <textarea id={ids.about}
                                              className="form-control"
                                              value={about}
                                              style={{minHeight:100,maxHeight:200}}
                                              onChange={e => {
                                                  const t = e.currentTarget.value;
                                                  setAbout(t);
                                              }}
                                    />
                                    <div style={{height: 15}}/>
                                    <label>نوع:</label>
                                    <button className={"techaran-radio-box" + (mode === 'all' ? ' active' : '')}
                                            onClick={() => setMode('all')}>
                                        <div><i/></div>
                                        <span>همگانی</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (mode === 'class' ? ' active' : '')}
                                            onClick={() => setMode('class')}>
                                        <div><i/></div>
                                        <span>کلاسی</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (mode === 'students' ? ' active' : '')}
                                            onClick={() => setMode('students')}>
                                        <div><i/></div>
                                        <span>افراد خاص</span>
                                    </button>
                                    <div style={{height: 15}}/>
                                    {
                                        mode === 'class' ?
                                            <>
                                                <label style={{display: 'block'}}>کلاس هدف:</label>
                                                {
                                                    classes.map((c, i) =>
                                                        <button key={"Az39r578FF22244_3" + i}
                                                                style={{width: '50%', display: 'inline-flex'}}
                                                                className={"techaran-radio-box" + (classSelected === c.id ? ' active' : '')}
                                                                onClick={() => setClassSelected(c.id)}>
                                                            <div><i/></div>
                                                            <span>{c.title}</span>
                                                        </button>
                                                    )
                                                }
                                                <div style={{height: 15}}/>
                                            </> : null
                                    }
                                </div>
                                <div className="col-lg-6">
                                    <label>تاریخ پایان مهلت ثبت‌نام:</label>
                                    <Calendar
                                        value={expiresAt}
                                        onChange={e => setExpiresAt(e)}
                                        shouldHighlightWeekends
                                        colorPrimary='#0a53be'
                                        locale='fa'
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center"
                                 style={{gap: 20, marginTop: 30}}>
                                <button className="cancel-button" onClick={props.closeHandler}>
                                    <b>انصراف</b>
                                </button>
                                <button className="btn-pay" onClick={saveChanges}>
                                    <b>ذخیره تغییرات</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};